export default defineNuxtPlugin(() => {
  //#region 调取App函数
  /*

  jsNative
  管理 App webView 和 网页端的通讯

使用例子
appFun(函数名字，传递的参数,function(data){
    data 为客户端返回的数据
})

或者没有传递参数的
appFun(函数名字，function(data){
    data 为客户端返回的数据
})

*/
  let appid = 0
  const native: any = {}
  const iosNeedMessageFun = [
    'getRoomUserDetail', //  获取 uid，ticket，language，roomId，roomUid
    'openUserInfoCard', // 打开个人主页
    'closeRoom', // 关闭房间
    'openKeyboardPage', // 打开礼物弹窗
    'openFacePage', // 打开表情栏
    'openMoreSettingPage', // 打开房间更多设置
    'openToolsPage', // 打开房间底部工具栏  传参{ chatZone: 0 | 1, rideEffects: 0 | 1, isAdmin: 1 | 0 }  chatZone和rideEffects对应1为关闭  0为开启
    'openGroupNotification', // 打开房间公告 传参{ roomNotice, roomDesc, isAdmin: 1 | 0 }
    'openInviteUserUpMic', // 打开邀请弹窗
    'updateRoomId', // 通知更新房间id
    'openTreasureBallPage', // 打开爆蛋半屏页面v120
    'updateTreasureBallValue', // 更新爆蛋值 v120
    'sendMessageReport', // 收到礼物横幅播放横幅v120
    'getVersionCode', // 获取版本号v120 eg. 1.2.0
    'openRoomBanner', // 打开房间活动banner v120
    'getRoomInfo', // 通知客户端更新房间信息 v130
    'getSelfUserInfo', // 获取用户信息 v130
    'getRoomInfo', // 通知客户端更新房间信息 v130
    'openLuckyBag', // 打开幸运红包弹窗/页面 v150
    'jumpToOtherRoom', // 跳转其他房间确认弹窗 v150
    'socketSend' // IOS房间 发送socket请求
  ]
  const iosGetMessageFun: any = {
    getRoomUserDetail: 'getRoomUserDetail',
    openUserInfoCard: 'openUserInfoCard',
    closeRoom: 'closeRoom',
    openKeyboardPage: 'openKeyboardPage', // 打开礼物弹窗
    openFacePage: 'openFacePage', // 打开表情栏
    openMoreSettingPage: 'openMoreSettingPage',
    openToolsPage: 'openToolsPage',
    openGroupNotification: 'openGroupNotification',
    openInviteUserUpMic: 'openInviteUserUpMic',
    updateRoomId: 'updateRoomId',
    openTreasureBallPage: 'openTreasureBallPage',
    sendMessageReport: 'sendMessageReport',
    getVersionCode: 'versionCode',
    getSelfUserInfo: 'getSelfUserInfo'
  }
  const androidNeedMessageFun = []
  const rnFun: any = {
    getNative: 'native'
  }
  const system = (function () {
    const sysJuc = {
      ios: /(iPhone|iPad|iPod|iOS)/i,
      android: /(Android)/i
    }
    const nav = navigator.userAgent
    return sysJuc.ios.test(nav)
      ? 'ios'
      : sysJuc.android.test(nav)
        ? 'android'
        : 'other'
  })()
  window['appSystem'] = system
  function isFun(fun: any) {
    return Object.prototype.toString.call(fun) == '[object Function]'
  }
  function isJSONStr(str: string) {
    if (typeof str == 'string') {
      try {
        const obj = JSON.parse(str)
        if (typeof obj == 'object') {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    } else {
      return false
    }
  }
  // eslint-disable-next-line prettier/prettier
  window['shareInfo'] = function () {}

  window['appCallJs'] = function (data: any) {
    data = isJSONStr(data) ? JSON.parse(data) : data
    native[data.id] && native[data.id](data.data)
    delete native[data.id]
  }

  window['getMessage'] = function (id: any, data: any) {
    console.log('客户端回调getMessage => ', id, data)
    data = isJSONStr(data) ? JSON.parse(data) : data
    native[id] && native[id](data)
    delete native[id]
  }

  window['appFun'] = function () {
    // eslint-disable-next-line prefer-rest-params
    const arg = arguments
    const funName = Array.prototype.shift.call(arg)
    let appObj: any = {}
    const callback = isFun(arg[0]) ? arg[0] : arg[1]
    isFun(arg[0]) ? (arg[0] = undefined) : ''
    try {
      console.log('调用客户端方法 => ', funName, arg[0])
      if (system === 'ios') {
        if (window['webkit'].messageHandlers[funName]) {
          appObj = window['webkit'].messageHandlers
        } else {
          appObj = window['ReactNativeWebView']
        }
        if (iosNeedMessageFun.indexOf(funName) > -1) {
          let key = appid
          key = iosGetMessageFun[funName] || key
          native[key] = function (data: any) {
            callback && callback(data)
          }
          if (arg[0] !== undefined) {
            const data = {
              id: key,
              data: {}
            }
            if (isJSONStr(arg[0])) {
              data.data = JSON.parse(arg[0])
            } else {
              data.data = arg[0]
            }
            if (arg[0] == 'noParam') {
              data.data = {}
            }
            arg[0] = JSON.stringify(data)
            // eslint-disable-next-line no-prototype-builtins
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(
                JSON.stringify({ type: funName, data: arg[0] || null })
              )
            } else {
              if (rnFun[funName]) {
                //rn 独有方法
                return
              }
              appObj[funName] && appObj[funName].postMessage(arg[0])
            }
          } else {
            // eslint-disable-next-line no-prototype-builtins
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(
                JSON.stringify({ type: funName, data: arg[0] || null })
              )
            } else {
              if (rnFun[funName]) {
                return
              }
              appObj[funName] && appObj[funName].postMessage(null)
            }
          }
          appid++
        } else {
          if (arg[0] !== undefined) {
            // eslint-disable-next-line no-prototype-builtins
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(
                JSON.stringify({ type: funName, data: arg[0] || null })
              )
            } else {
              if (rnFun[funName]) {
                return
              }
              appObj[funName] && appObj[funName].postMessage(arg[0])
            }
          } else {
            // eslint-disable-next-line no-prototype-builtins
            if (appObj.hasOwnProperty('postMessage')) {
              appObj.postMessage(
                JSON.stringify({ type: funName, data: arg[0] || null })
              )
            } else {
              if (rnFun[funName]) {
                return
              }
              appObj[funName] && appObj[funName].postMessage(null)
            }
          }
        }
      } else {
        appObj = window['androidJsObj']
        if (rnFun[funName]) {
          callback && callback(rnFun[funName])
          return
        }
        if (androidNeedMessageFun.indexOf(funName as never) > -1) {
          native[appid] = function (data: any) {
            callback && callback(data)
          }
          if (arg[0] !== undefined) {
            const data = {
              id: appid,
              data: {}
            }
            if (isJSONStr(arg[0])) {
              data.data = JSON.parse(arg[0])
            } else {
              data.data = arg[0]
            }
            arg[0] = JSON.stringify(data)

            appObj[funName](arg[0])
          } else {
            appObj[funName]()
          }
          appid++
        } else {
          if (arg[0] !== undefined && arg[0] !== 'noParam') {
            callback
              ? callback(appObj[funName](arg[0]))
              : appObj[funName](arg[0])
          } else {
            callback ? callback(appObj[funName]()) : appObj[funName]()
          }
        }
      }
    } catch (e) {
      console.log(e, '错误')
    }
  }
  //#endregion
})
